import { Box, Divider, styled, Typography } from "@mui/material";
import { getColor } from "../color/color";
import { fonts } from "../fonts/fonts";

export const ImageWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "10%",
  marginBottom: " 80px",
}));
export const StyledDivider = styled(Divider)(({ theme }) => ({
  color: getColor.Platinum,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));
export const StyledQuestionTypography = styled(Typography)(({ theme }) => ({
  color: getColor.NeutralDark700,
  fontSize: "1rem",
  fontFamily: fonts.manrope,
  fontWeight: 700,
  //   marginTop: theme.spacing(2),
  //   marginBottom: theme.spacing(2),
  //   marginLeft: theme.spacing("30px"),
}));
export const commanButtomStyled = (activeButton, buttonId, bgColor) => ({
  height: "50px",
  width: "170px",
  fontSize: 16,
  fontFamily: fonts.manrope,
  fontWeight: "500",
  textTransform: "initial",
  color:
    activeButton === buttonId
      ? getColor.PrimaryWhite
      : getColor.SecondaryMidnightBlue,
  backgroundColor:
    activeButton === buttonId
      ? bgColor
      : getColor.ExtendedPalettesSummerSkySS100,
  marginRight: { xs: 0, sm: "20px" },
  marginBottom: { xs: "10px", sm: 0 },
  padding: "15px",
  borderRadius: "10px",
});

export const StyledTextContent = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  marginTop: theme.spacing("20px"),
  fontWeight: 400,
  fontFamily: fonts.manrope,
}));
export const acrButtonStyle = {
  width: "100%",
  height: "60px",
  maxWidth: "350px",
  backgroundColor: getColor.ColorButtonPrimarysurface,
  color: getColor.PrimaryWhite,
  borderRadius: "40px",
  p: "10px",
  mt: "40px",
  mb: "40px",
  lineHeight: "22.2px",
  fontWeight: 700,
  fontSize: "16px",
  textAlign: "center",
  textTransform: "initial",
};
